import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class SelectHaulerTemplateArgs extends ActionArgs {
  /** The `Template._id` of the app-level hauler-catalog row to snapshot. */
  @Field(() => ID)
  templateId: string
}
